export default __webpack_public_path__ + "static/media/edit.21822e8c.svg";